import { render, staticRenderFns } from "./EduHead.vue?vue&type=template&id=2168e518&scoped=true&"
import script from "./EduHead.vue?vue&type=script&lang=js&"
export * from "./EduHead.vue?vue&type=script&lang=js&"
import style0 from "./EduHead.vue?vue&type=style&index=0&id=2168e518&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2168e518",
  null
  
)

export default component.exports